import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints, palette, fontSizes, lineHeights, fontWeights,
}: Theme) => ({
  paper: {
    '&&': {
      width: '20.5rem',
      maxWidth: '100%',
      borderRadius: '0.5rem',
      paddingTop: '2rem',
      paddingBottom: '2rem',
      [breakpoints.up('md')]: {
        width: '31.25rem',
        paddingTop: '3rem',
        paddingBottom: '3rem',
      },
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    [breakpoints.up('md')]: {
      gap: '2rem',
    },
    '&&': {
      paddingLeft: '1rem',
      paddingRight: '1rem',
      [breakpoints.up('md')]: {
        paddingLeft: '3rem',
        paddingRight: '3rem',
      },
    },
  },
  imageWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '10.25rem',
    borderRadius: '1rem',
    background: 'linear-gradient(306.14deg, #fffbef 24.06%, #d8fbff 57.21%)',
    [breakpoints.up('md')]: {
      height: '14.25rem',
    },
    '& svg': {
      width: '7.75',
      height: 'auto',
      objectFit: 'contain',
    },
  },
  imageText: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '9rem',
    height: '9rem',
    borderRadius: '50%',
    background: 'linear-gradient(332.61deg, #91e6d6 12.62%, #21acb9 85.99%)',
    color: palette.common.white,
    fontSize: '2.25rem',
    fontWeight: fontWeights.medium,
    lineHeight: 1.3,
  },
  title: {
    fontWeight: fontWeights.medium,
    [breakpoints.up('md')]: {
      fontSize: '1.75rem',
      lineHeight: 1.3,
    },
  },
  description: {
    margin: 0,
    fontSize: fontSizes.xs,
    lineHeight: lineHeights.sm,
    [breakpoints.up('sm')]: {
      fontSize: fontSizes.sm,
      lineHeight: lineHeights.md,
    },
  },
}));
